export default __webpack_public_path__ + "static/business-name-e12382a498cbab3098114eae6d0d90c0.webp";